function aboutQualityViewAllContents() {
    const viewAllButton = document.getElementById("aboutQualityViewAll");
    const mobileContentsSection = document.getElementById("abourQualityMobileContents");
    const mobileFullContentsSection = document.getElementById("abourQualityMobileContentsFull");
    const isShowingLess = viewAllButton.innerText === "SHOW LESS";
    viewAllButton.innerText = isShowingLess ? "VIEW ALL" : "SHOW LESS";
    mobileContentsSection.classList.toggle("hidden");
    mobileFullContentsSection.classList.toggle("hidden");
}
